import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartType } from 'angular-google-charts';
import { Chart } from 'angular-highcharts';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';

interface IChart {
  title: string;
  type: ChartType;
  data: any[][];
  columns: string[];
  options: any[];
  width: number;
  height: number;
}

interface FoodNode {
  name: string;
  rut: string;
  children?: FoodNode[];
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  rut: string;
  level: number;
}

@Component({
  selector: 'app-reporte-viewer',
  templateUrl: './reporte-viewer.component.html',
  styleUrls: ['./reporte-viewer.component.scss']
})
export class ReporteViewerComponent implements OnInit {
  @Input() content: any = null;

  @Output() descargarTX = new EventEmitter<string>();

  public chart: IChart;
  public riesgoIndustriaCalculado = "";
  public riesgoIndustriaCalculadoValue = 0;
  public clasificacionRiesgoStyle = 7;
  public showAntecedentesSocietarios = false;
  public showAntecedentesComerciales = false;
  public showInformacionSectorialyDeMercado = false;
  public showDetalleMorosidadesYProtestos = false;
  public showInformacionBoletinComercialLaboral = false;
  public showClasificacionRiesgo = false;
  public showConsultaRut: boolean = false;
  public sinInformeText: string = 'Reporte Basico - Sin Informe Comercial';
  public graph: any = {};
  public isPersonaNatural: boolean = false;
  public reporteConInformeComercial: boolean = false;
  public telefonos: any[] = [];
  public direccion: string = '';
  public rut: string = '';
  public today: string = '';

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      rut: node.rut,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    (node: any) => node.level,
    (node: any) => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node: ExampleFlatNode) => node.level,
    (node: ExampleFlatNode) => node.expandable,
    (node: FoodNode) => node.children
  );

  dataSourceTreeSocios = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  constructor(private utilService: UtilsService) {
    this.chart = {
      title: "Ventas expresadas en millones de UF",
      type: ChartType.ColumnChart,
      data: [],
      columns: ['Topping', 'Ventas'],
      options: [],
      width: 490,
      height: 250
    }
  }

  ngOnInit(): void {
    this.rut = this.content?.InformacionBasica?.Rut || '';
    this.setToday();
    
    if (this.content?.Riesgo?.ClasificacionHistorica && this.content?.Riesgo?.ClasificacionHistorica.length > 0) {
      this.setGrafico();
    }

    if (this.content.AntecedentesSocietarios && this.content.AntecedentesSocietarios !== "") {
      this.showAntecedentesSocietarios = true;
    }

    if (
      this.content.AntecedentesComerciales
      && this.content.AntecedentesComerciales.Resumen) {
      this.showAntecedentesComerciales = true;
    }

    if (
      this.content.InformacionSectorialyDeMercado
      && this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF
      && this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano1
      && this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano1 !== "") {
      this.showInformacionSectorialyDeMercado = true;
    }

    if (
      this.content.AntecedentesComerciales
      && this.content.AntecedentesComerciales.DetalleMorosidadesYProtestos
      && this.content.AntecedentesComerciales.DetalleMorosidadesYProtestos !== ""
    ) {
      this.showDetalleMorosidadesYProtestos = true;
    }

    if (
      this.content.AntecedentesComerciales
      && this.content.AntecedentesComerciales.ConsultasAlRut
      && this.content.AntecedentesComerciales.ConsultasAlRut.length > 0
    ) {
      this.showConsultaRut = true;
    }

    if (
      this.content.AntecedentesComerciales
      && this.content.AntecedentesComerciales.InformacionBoletinComercialLaboral
      && this.content.AntecedentesComerciales.InformacionBoletinComercialLaboral !== ""
    ) {
      this.showInformacionBoletinComercialLaboral = true;
    }

    this.formatInicioActividadesDate();
    this.setRiesgoIndustrialCalculado();
    this.setChartData();

    if(this.content.InformacionBasica?.TipoReporte !== this.sinInformeText) {
      this.reporteConInformeComercial = true;
    } else {
      this.reporteConInformeComercial = false;
    }

    if (
      this.content.Riesgo
      && this.content.Riesgo.ClasificacionRiesgo
    ) {
      this.showClasificacionRiesgo = true;
      this.clasificacionRiesgoStyle = this.content.Riesgo.ClasificacionRiesgo / 10;
    }

    if(this.content.InformacionBasica.Rut) {
      let rut = this.content.InformacionBasica.Rut;
      if(rut.includes('.')) {
        rut = rut.replace(/\./g, '');
      }
      if(rut.includes('-')) {
        rut = rut.split('-')[0];
      }
      this.isPersonaNatural = Number(rut) > 50000000 ? false : true;
      this.getTelefonos();
      this.getDireccion();
    }

    // espera un ciclo
    setTimeout(() => {
      this.generateObjects();
    }, 0);

  }

  setToday() {
    this.today = `${new Date().getFullYear()}${(new Date().getMonth() + 1 < 10?  '0'+(new Date().getMonth() + 1) : 
      new Date().getMonth() + 1)}${new Date().getDate()}`;        
  }

  public getDireccion(): void {
    if(this.isPersonaNatural) {
      if(this.content?.InformacionPersonal?.Contactabilidad?.Direcciones && this.content?.InformacionPersonal?.Contactabilidad?.Direcciones.length > 0) {
        const direccionesParticulares: any[] = this.content?.InformacionPersonal?.Contactabilidad?.Direcciones.filter((direccion: any) => direccion.TipoDireccion === 'PARTICULAR');
        if(direccionesParticulares && direccionesParticulares.length > 0) {
          const direccionPReciente = direccionesParticulares.sort((a: any, b: any) => (a.FechaDireccion < b.FechaDireccion ? 1 : -1))[0];
          if(direccionPReciente) {
            this.direccion = `${direccionPReciente.CalleyNumero}${direccionPReciente.Comuna ? ', ' + direccionPReciente.Comuna : ''}${direccionPReciente.Ciudad ? ', ' + direccionPReciente.Ciudad : ''}`;
            return;
          }
        }
      }
      this.direccion = this.content?.InformacionBasica?.Direccion || '';
    } else {
      if(this.content?.InformacionBasica?.Direccion) {
        this.direccion = this.content?.InformacionBasica?.Direccion || '';
      }
    }
  }

  public getTelefonos(): void {
    if(this.isPersonaNatural) {
      if(this.content?.InformacionPersonal?.Contactabilidad?.Telefonos && this.content?.InformacionPersonal?.Contactabilidad?.Telefonos.length > 0) {
        if(this.content?.InformacionPersonal?.Contactabilidad?.Telefonos.length <= 2) {
          this.telefonos = this.content?.InformacionPersonal?.Contactabilidad?.Telefonos || [];
        } else {
          this.telefonos = this.content?.InformacionPersonal?.Contactabilidad?.Telefonos
          .sort((a: any, b: any) => (new Date(a.FechaTelefono).getTime() < new Date(b.FechaTelefono).getTime() ? 1 : -1)).slice(0, 2);
        }
      }
    } else {
      if(this.content?.ContactabilidadComercial?.Telefonos && this.content?.ContactabilidadComercial?.Telefonos.length > 0) {
        if(this.content?.ContactabilidadComercial?.Telefonos.length <= 2) {
          this.telefonos = this.content?.ContactabilidadComercial?.Telefonos || [];
        } else {
          this.telefonos = this.content?.ContactabilidadComercial?.Telefonos
          .sort((a: any, b: any) => (new Date(a.FechaTelefono).getTime() < new Date(b.FechaTelefono).getTime() ? 1 : -1)).slice(0, 2);
        }
      }
    }
  }

  public formatInicioActividadesDate(): void {
    let fecha = this.content.InformacionBasica.AnoInicioActividades.slice(0, 10);
    fecha = fecha.substr(2, 1) === '-' ? this.utilService.splitDate(fecha) : fecha;
    this.content.InformacionBasica.AnoInicioActividades = fecha;
  }

  public setRiesgoIndustrialCalculado(): void {
    if (!this.content.Riesgo) {
      this.riesgoIndustriaCalculado = "";
      this.riesgoIndustriaCalculadoValue = 100;
      return;
    }

    switch (this.content.Riesgo.RiesgoIndustria) {
      case "Alto":
        this.riesgoIndustriaCalculado = "Alto";
        this.riesgoIndustriaCalculadoValue = 10;
        break;
      case "Medio":
        this.riesgoIndustriaCalculado = "Medio";
        this.riesgoIndustriaCalculadoValue = 30;
        break;
      case "Medio Alto":
        this.riesgoIndustriaCalculado = "Medio Alto";
        this.riesgoIndustriaCalculadoValue = 50;
        break;
      case "Medio Bajo":
        this.riesgoIndustriaCalculado = "Medio Bajo";
        this.riesgoIndustriaCalculadoValue = 70;
        break;
      case "Bajo":
        this.riesgoIndustriaCalculado = "Bajo";
        this.riesgoIndustriaCalculadoValue = 90;
        break;
      default:
        this.riesgoIndustriaCalculado = "";
        this.riesgoIndustriaCalculadoValue = 100;
    }
  }

  public setChartData(): void {
    if (
      !this.content.InformacionSectorialyDeMercado
      || !this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF
      || !this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano1
      || !this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_1
    ) {
      return;
    }

    this.chart.data = [
      [String(this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano1), (this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_1) / 1000000],
      [String(this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano2), (this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_2) / 1000000],
      [String(this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano3), (this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_3) / 1000000],
      [String(this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano4), (this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_4) / 1000000],
      [String(this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.ano5), (this.content.InformacionSectorialyDeMercado.TotalVentasHistoricoUF.periodo_5) / 1000000],
    ]
  }

  setClasificacionPosition(value: string): number { 
    return Math.round((Number(value) * 100) / 1000);
  }

  /**
 * @description
 * Setea los valores de la grafica  
 */
  setGrafico(): void {
    const objTemp = this.content?.Riesgo?.ClasificacionHistorica
      .sort((a: any, b: any) => (new Date(a.Fecha).getTime() > new Date(b.Fecha).getTime() ? 1 : -1))
      .slice(-12);

    const categorias = objTemp.map((element: any) => {
      const fechaStr = element.Fecha;
      let fecha;

      fecha = new Date(fechaStr);

      if (isNaN(fecha.getTime())) {
        const [year, month, day] = fechaStr.split('-').map(Number);
        fecha = new Date(Date.UTC(year, month - 1, day));
      }

      if (isNaN(fecha.getTime())) {
        //console.error(`Fecha inválida: ${fechaStr}`);
        return null;
      }

      const mes = fecha.getUTCMonth() + 1;
      return `${fecha.getUTCFullYear()}/${mes}`;
    });

    const values = objTemp.map((element: any) => {
     return Number(element.Valor)
    });

    this.graph = new Chart({
      xAxis: [{
        categories: categorias
      }],
      title: {
        text: ''
      },
      yAxis: [{
        labels: {
          format: '{value}',
          style: {
            color: '#000'
          }
        },
        title: {
          text: '',
          style: {
            color: '#000'
          }
        }
      }],
      series: [{
        name: 'Puntajes',
        type: 'line',
        data: values,
        color: '#f00'
      }]
    });
  }

  formatFechaEmailPN(dateNumber: number): string {
    if(!dateNumber) {
      return '';
    }
    const dateString = dateNumber.toString();
  
    // Verificar si la cadena tiene exactamente 8 caracteres y solo contiene dígitos
    if (/^\d{8}$/.test(dateString)) { // formato es YYYYMMDD
      const year = dateString.substring(0, 4);
      const month = dateString.substring(4, 6);
      const day = dateString.substring(6, 8);
      return `${day}-${month}-${year}`;
    } else {
      return '';
    }
  }

  convertirFechaTelefono(fecha: any) {
    if(!fecha) return '';
    const date = new Date(fecha);
    const dia = String(date.getUTCDate()).padStart(2, '0');
    const mes = String(date.getUTCMonth() + 1).padStart(2, '0');
    const año = date.getUTCFullYear();
    return `${dia}-${mes}-${año}`;
  }


  formatInteger(num: any): string {
    if (num === 0) return '0';
    if(!num) return '';

    const roundedNum = Math.round(num);

    const isNegative = roundedNum < 0;
    const absoluteNum = Math.abs(roundedNum);

    let formattedNumber = absoluteNum.toLocaleString('de-DE');

    if (isNegative) {
        formattedNumber = `-${formattedNumber}`;
    }

    return formattedNumber;
  }

  public objReporte: any[] = [];

  /**
   * @description
   * Genera objetos necesarios para el reporte
   */
  generateObjects(): void {
    const infoBasica = this.generateInformacionBasica();
    const infoRiesgo = this.generateRiesgo();
    const antecedentesFinancieros = this.generateAntecedentesFinancieros();

    let evoPredictor: any = null;
    if(this.graph && this.content?.Riesgo?.ClasificacionHistorica && this.content?.Riesgo?.ClasificacionHistorica?.length > 0) {
      evoPredictor = this.generateEvolucionPredictor();
    }

    let antecedentesSocietarios: any = null;
    let antecedentesComerciales: any = null;
    if(this.content?.InformacionBasica?.TipoReporte !== this.sinInformeText) {
      antecedentesSocietarios = this.generateAntecedentesSocietarios();
      antecedentesComerciales = this.generateAntecedentesComerciales();
    }

    let antecedentesSociedades: any = null;
    if(this.reporteConInformeComercial === true) {
      antecedentesSociedades = this.generateAntecedentesSociedades();
    }

    const infoSectorialyMercado = this.generateInfoSectorialyMercado();
    const obsTributarias = this.generateObsTributarias();

    let consAlRut: any = null;
    if(this.content?.AntecedentesComerciales?.ConsultasAlRut && this.content?.AntecedentesComerciales?.ConsultasAlRut.length > 0) {
      consAlRut = this.generateConsAlRut();
    }
    
    let protestosYMorosidad: any = null;
    let informacionBoletinLaboral: any = null;
    if(this.content?.InformacionBasica?.TipoReporte !== this.sinInformeText) {
      protestosYMorosidad = this.generateProtestosYMorosidad();
      informacionBoletinLaboral = this.generateInformacionBoletinLaboral();
    }

    this.objReporte = [
      infoBasica,
      infoRiesgo,
      antecedentesFinancieros
    ];

    if(evoPredictor) {
      this.objReporte.push(evoPredictor);
    }
    if(antecedentesSocietarios) {
      this.objReporte.push(antecedentesSocietarios);
    }
    if(antecedentesComerciales) {
      this.objReporte.push(antecedentesComerciales);
    }
    if(antecedentesSociedades) {
      this.objReporte.push(antecedentesSociedades);
    }
    this.objReporte.push(infoSectorialyMercado);
    this.objReporte.push(obsTributarias);
    if(consAlRut){
      this.objReporte.push(consAlRut);
    }
    if(protestosYMorosidad) {
      this.objReporte.push(protestosYMorosidad);
    }
    if(informacionBoletinLaboral){
      this.objReporte.push(informacionBoletinLaboral);
    }
  }

  generateInformacionBasica(): any {
    // Lógica para generar la información básica
    const obj: any = this.createMatObj('Información Básica', 'col-sm-12 col-md-6');

    const dataSourceTable: any[] = [];

    dataSourceTable.push(
      {name: 'Rut', value: this.content?.InformacionBasica?.Rut, type: 'rut'}
    );
    dataSourceTable.push(
      {
        name: 'Nombre',
        value: this.content?.InformacionBasica?.NombreORazonSocial,
        type: 'text'
      }
    );
    dataSourceTable.push(
      {
        name: 'Fecha',
        value: this.content?.InformacionBasica?.FechaReporte,
        type: 'date'
      }
    );
    dataSourceTable.push(
      {
        name: 'Id',
        value: this.content?.InformacionBasica?.IDTransaccion,
        type: 'text'
      }
    );
    dataSourceTable.push(
      {
        name: 'Iniciación de Actividades',
        value: this.content?.InformacionBasica?.AnoInicioActividades,
        type: 'date'
      }
    );

    if((this.isPersonaNatural && this.reporteConInformeComercial === true) || !this.isPersonaNatural) {
      dataSourceTable.push(
        {
          name: 'Dirección',
          value: this.direccion,
          type: 'text'
        }
      )
    }

    if(!this.isPersonaNatural) {
      dataSourceTable.push(
        {
          name: 'Tipo de Sociedad',
          value: this.content.InformacionBasica.TipoSociedad,
          type: 'text'
        }
      );
    }

    if(this.content?.InformacionBasica?.TerminoGiro) {
      dataSourceTable.push(
        {
          name: 'Término de Giro',
          value: this.content?.InformacionBasica?.TerminoGiro,
          type: 'text'
        }
      );
    }

    if(this.isPersonaNatural) {
      if(this.reporteConInformeComercial === true) {
        dataSourceTable.push(
          {
            name: 'Edad',
            value: this.content?.InformacionPersonal?.Edad,
            type: 'text'
          }
        );

        dataSourceTable.push(
          {
            name: 'Fecha Nacimiento',
            value: this.content?.InformacionPersonal?.FechaNacimiento,
            type: 'date'
          }
        );

        dataSourceTable.push(
          {
            name: 'Nacionalidad',
            value: this.content?.InformacionPersonal?.Nacionalidad,
            type: 'text'
          }
        );

        if(this.telefonos && this.telefonos.length > 0) {
          if(this.telefonos.length > 1) {
            dataSourceTable.push(
              {
                name: `Teléfonos`,
                value: '',
                type: 'text'
              }
            );
            for(const [index, telefono] of this.telefonos.entries()) {
              dataSourceTable.push(
                {
                  name: ``,
                  value: `${index + 1}: ${telefono?.Telefono}`,
                  type: 'text'
                }
              );
            }
          } else {
            dataSourceTable.push(
              {
                name: 'Teléfono',
                value: this.telefonos[0]?.Telefono,
                type: 'text'
              }
            );
          }
        }

        dataSourceTable.push(
          {
            name: 'Email',
            value: this.content?.InformacionPersonal?.Contactabilidad?.Email?.Email,
            type: 'text'
          }
        );

        dataSourceTable.push(
          {
            name: 'Fecha Email',
            value: this.formatFechaEmailPN(this.content?.InformacionPersonal?.Contactabilidad?.Email?.FechaEmail),
            type: 'text'
          }
        );

        dataSourceTable.push(
          {
            name: 'Descripcion Estado Marital',
            value: this.content?.InformacionPersonal?.Familia?.DescripcionEstadoMarital,
            type: 'text'
          }
        );

        dataSourceTable.push(
          {
            name: 'Rut Conyugue',
            value: this.content?.InformacionPersonal?.Familia?.RutConyugue,
            type: 'rut'
          }
        );

        dataSourceTable.push(
          {
            name: 'Fecha de Matrimonio',
            value: this.content?.InformacionPersonal?.Familia?.FechaDeMatrimonio,
            type: 'date'
          }
        )

      }
    } else {
      if(this.telefonos && this.telefonos.length > 0) {
        if(this.telefonos.length > 1) {
          for(const [index, telefono] of this.telefonos.entries()) {
            dataSourceTable.push(
              {
                name: `Teléfono ${index + 1}`,
                value: '',
                type: 'text'
              }
            );
            dataSourceTable.push(
              {
                name: ``,
                value: `Número: ${telefono?.Telefono}`,
                type: 'text'
              }
            );
            dataSourceTable.push(
              {
                name: ``,
                value: `Fecha Teléfono: ${this.convertirFechaTelefono(telefono?.FechaTelefono)}`,
                type: 'text'
              }
            );
          }
        } else {
          dataSourceTable.push(
            {
              name: 'Teléfono',
              value: this.telefonos[0]?.Telefono,
              type: 'text'
            }
          );
          dataSourceTable.push(
            {
              name: 'Fecha Teléfono',
              value: this.telefonos[0]?.FechaTelefono,
              type: 'date'
            }
          );
        }

      }
      if(this.reporteConInformeComercial === true) {
        dataSourceTable.push(
          {
            name: 'Email',
            value: this.content?.ContactabilidadComercial?.Email,
            type: 'text'
          }
        );
        dataSourceTable.push(
          {
            name: 'Sitio Web',
            value: this.content?.ContactabilidadComercial?.SitioWeb,
            type: 'text'
          }
        );
      }
    }

    const tabla = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTable
    };

    obj.content.push(tabla);

    return obj || {};
  }

  generateRiesgo(): any {
    // Lógica para generar la información de riesgo
    const obj: any = this.createMatObj('Riesgo', 'col-sm-12 col-md-6');

    const dataSourceTable: any[] = [];

    dataSourceTable.push(
      {name: 'Actividad Económica', value: this.content?.Riesgo?.ActividadEconomica, type: 'text'}
    );
    dataSourceTable.push(
      {
        name: 'Industria',
        value: this.content?.Riesgo?.Industria,
        type: 'text'
      }
    );
    dataSourceTable.push(
      {
        name: 'Sub sector',
        value: this.content?.Riesgo?.Subsector,
        type: 'text'
      }
    );
    dataSourceTable.push(
      {
        name: 'Riesgo Industria',
        value: this.content?.Riesgo?.RiesgoIndustria,
        type: 'text'
      }
    );
    const tabla = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTable
    };

    obj.content.push(tabla);

    if(this.riesgoIndustriaCalculado) {
      obj.content.push({
        name: '',
        value: this.riesgoIndustriaCalculado,
        type: 'graphRiesgoCalculado'
      });
    }

    if(this.content?.Riesgo?.ClasificacionRiesgo) {
      obj.content.push({
        name: 'Clasificación Riesgo',
        value: this.content?.Riesgo?.ClasificacionRiesgo,
        type: 'graphRiesgoBarra'
      });
    }
    if(this.content?.Riesgo?.Clasificacion) {
      obj.content.push({
        name: 'Clasificación Comercial',
        value: this.content?.Riesgo?.Clasificacion,
        type: 'graphRiesgoBarra'
      });
    }
    if(this.content?.Riesgo?.Rating) {
      obj.content.push({
        name: 'Rating',
        value: this.content?.Riesgo?.Rating,
        type: 'graphRiesgoBarra'
      });
    }

    return obj || {};
  }

  generateAntecedentesFinancieros(): any {
    // Lógica para generar los antecedentes financieros
    const obj: any = this.createMatObj('Antecedentes Financieros', 'col-sm-12 col-md-6');

    const dataSourceTable: any[] = [];

    if(!this.isPersonaNatural) {
      dataSourceTable.push(
        {
          name: 'Est. Financieros',
          value: this.content?.AntecedentesFinancieros?.EstadosFinancieros,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'F. E. Financiero',
          value: this.content?.AntecedentesFinancieros?.FechaEstadosFinancieros,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'T. Emp. Descripción',
          value: this.content?.AntecedentesFinancieros?.TamanoEmpresaDescripcion,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'T. Emp. Rango',
          value: this.content?.AntecedentesFinancieros?.TamanoEmpresaRango,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'T. Sub Segmento',
          value: this.content?.AntecedentesFinancieros?.TamanoSubsegmento,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'Tramo',
          value: this.content?.AntecedentesFinancieros?.TramoSegunVentas,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'Patrimonio',
          value: this.content?.AntecedentesFinancieros?.Patrimonio,
          type: 'text'
        }
      );

      dataSourceTable.push(
        {
          name: 'Cant. Empleados',
          value: this.content?.AntecedentesFinancieros?.NumeroEmpleados,
          type: 'text'
        }
      );
    }

    dataSourceTable.push(
      {
        name: `Número de Vehiculos: ${this.formatInteger(this.content?.AntecedentesFinancieros?.NumeroVehiculos)}`,
        value: `Valor de Vehiculos: ${this.formatInteger(this.content?.AntecedentesFinancieros?.ValorVehiculos)}`,
        type: 'text'
      }
    );

    dataSourceTable.push(
      {
        name: `Número de Bienes Raices: ${this.formatInteger(this.content?.AntecedentesFinancieros?.NumeroBienesRaices)}`,
        value: `Valor de Bienes Raices: ${this.formatInteger(this.content?.AntecedentesFinancieros?.ValorBienesRaices)}`,
        type: 'text'
      }
    );


    const tabla = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTable
    };
    obj.content.push(tabla);
    return obj || {};
  }

  generateEvolucionPredictor(): any {
    // Lógica para generar la evolución del predictor
    const obj: any = this.createMatObj('Evolución del Predictor Empresarial', 'col-sm-12 col-md-6');

    obj.content.push({
      name: '',
      value: this.graph,
      type: 'graphEvolucionPredictor'
    });

    return obj || {};
  }

  generateAntecedentesSocietarios(): any {
    // Lógica para generar los antecedentes societarios
    const obj: any = this.createMatObj('Antecedentes Societarios', 'col-sm-12 col-md-6');

    const dataSourceTable: any[] = [];

    dataSourceTable.push(
      {name: 'Rut', value: this.content?.InformacionBasica?.Rut, type: 'rut'}
    );
    dataSourceTable.push(
      {
        name: 'Nombre',
        value: this.content?.InformacionBasica?.NombreORazonSocial,
        type: 'text'
      }
    );
    
    const tabla = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTable
    };

    obj.content.push(tabla);

    const socios: any = [];

    if(this.content?.AntecedentesSocietarios && this.content?.AntecedentesSocietarios?.length > 0) {
      for(const socio of this.content?.AntecedentesSocietarios) {
        socios.push({
          name: socio?.nombre,
          rut: socio?.rut
        });
      }
    }

    obj.content.push({
      name: '',
      value: '',
      type: 'tree-societarios'
    });

    const data = {
      name: this.content?.InformacionBasica?.NombreORazonSocial,
      rut: this.content?.InformacionBasica?.Rut,
      children: socios,
    }

    this.dataSourceTreeSocios.data = [data];
    this.treeControl.expandAll();

    return obj || {};
  }

  generateAntecedentesComerciales(): any {
    // Lógica para generar los antecedentes comerciales
    const obj: any = this.createMatObj('Antecedentes Comerciales', 'col-sm-12 col-md-6');

    const dataSourceTable: any[] = [];

    dataSourceTable.push(
      {
        label: {
          value: "Protestos",
          type: 'text',
          class: ''
        },
        montoMiles: {
          value: this.content?.AntecedentesComerciales?.Resumen?.ProtestosMonto,
          type: 'int',
          class: ''
        },
        cantidad: {
          value: this.content?.AntecedentesComerciales?.Resumen?.ProtestoCantidad,
          type: 'int',
          class: ''
        }
      }
    );

    dataSourceTable.push(
      {
        label: {
          value: "Morosidades",
          type: 'text',
          class: ''
        },
        montoMiles: {
          value: this.content?.AntecedentesComerciales?.Resumen?.MorosidadesMonto,
          type: 'int',
          class: ''
        },
        cantidad: {
          value: this.content?.AntecedentesComerciales?.Resumen?.MorosidadesCantidad,
          type: 'int',
          class: ''
        }
      }
    );

    dataSourceTable.push(
      {
        label: {
          value: "Infracciones Laborales",
          type: 'text',
          class: ''
        },
        montoMiles: {
          value: this.content?.AntecedentesComerciales?.Resumen?.InfraccionesLaboralesMonto,
          type: 'int',
          class: ''
        },
        cantidad: {
          value: this.content?.AntecedentesComerciales?.Resumen?.InfraccionesLaboralesCantidad,
          type: 'int',
          class: ''
        }
      }
    );

    dataSourceTable.push(
      {
        label: {
          value: "Total",
          type: 'text',
          class: 'primary-container'
        },
        montoMiles: {
          value: this.content?.AntecedentesComerciales?.Resumen?.TotalImpagosMonto,
          type: 'int',
          class: 'primary-container'
        },
        cantidad: {
          value: this.content?.AntecedentesComerciales?.Resumen?.TotalImpagosCantidad,
          type: 'int',
          class: 'primary-container'
        }
      }
    );

    const tabla = {
      type: 'table-header',
      displayedColumns: ['label', 'montoMiles', 'cantidad'],
      headers: {
        label: '',
        montoMiles: 'Monto Miles',
        cantidad: 'Cantidad'
      },
      dataSource: dataSourceTable
    };

    obj.content.push(tabla);

    return obj || {};
  }

  generateAntecedentesSociedades(): any {
    // Lógica para generar los antecedentes de sociedades
    const obj: any = this.createMatObj('Antecedentes Sociedades', 'col-sm-12');

    const dataSourceTable: any[] = [];

    if(this.isPersonaNatural) {
      if(this.content?.AntecedentesSociedades && this.content?.AntecedentesSociedades.length > 0) {
        for(const itemSociedad of this.content?.AntecedentesSociedades) {
          dataSourceTable.push(
            {
              rut: {
                value: itemSociedad?.Rut,
                type: 'rut',
                class: ''
              },
              nombre: {
                value: itemSociedad?.Nombre,
                type: 'text',
                class: ''
              }
            }
          );
        }
      } else {
        dataSourceTable.push(
          {
            rut: {
              value: "Sin Información",
              type: 'text',
              class: ''
            },
            nombre: {
              value: "",
              type: 'text',
              class: ''
            }
          }
        );
      }
    } else {
      if(this.content?.AntecedentesSociedades && this.content?.AntecedentesSociedades.length > 0) {
        for(const itemSociedad of this.content?.AntecedentesSociedades) {
          dataSourceTable.push(
            {
              rut: {
                value: itemSociedad?.Rut,
                type: 'text',
                class: ''
              },
              nombre: {
                value: itemSociedad?.Nombre,
                type: 'text',
                class: ''
              }
            }
          );
        }
      } else {
        dataSourceTable.push(
          {
            rut: {
              value: "Sin Información",
              type: 'text',
              class: ''
            },
            nombre: {
              value: "",
              type: 'text',
              class: ''
            }
          }
        );
      }
    }

    const tabla = {
      type: 'table-header',
      displayedColumns: ['rut', 'nombre'],
      headers: {
        rut: 'Rut',
        nombre: 'Nombre'
      },
      dataSource: dataSourceTable
    };

    obj.content.push(tabla);

    return obj || {};
  }

  generateInfoSectorialyMercado(): any {
    // Lógica para generar la información sectorial y de mercado
    const obj: any = this.createMatObj('Información Sectorial y de Mercado', 'col-sm-12');

    const mercado: any = this.createCardObj('card', 'Mercado', 'col-sm-12 col-md-6');

    const dataSourceTableMercado: any[] = [];

    dataSourceTableMercado.push(
      {
        name: 'Número empresas',
        value: this.content?.InformacionSectorialyDeMercado?.TamanoMercadoNumeroEmpresas,
        type: 'int-clp'
      }
    );

    dataSourceTableMercado.push(
      {
        name: 'Total ventas en UF',
        value: this.content?.InformacionSectorialyDeMercado?.TotalVentasIndustriaEnUF,
        type: 'int-clp'
      }
    );

    dataSourceTableMercado.push(
      {
        name: 'Participacion relativa',
        value: this.content?.InformacionSectorialyDeMercado?.ParticipacionRelativa,
        type: 'text'
      }
    );

    dataSourceTableMercado.push(
      {
        name: 'Tendencia mercado',
        value: this.content?.InformacionSectorialyDeMercado?.TendenciaMercado,
        type: 'text'
      }
    );

    dataSourceTableMercado.push(
      {
        name: 'Variacion crecimiento anual',
        value: this.content?.InformacionSectorialyDeMercado?.VariacionVentasCrecimientoAnual,
        type: 'text'
      }
    );

    const tablaMercado = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTableMercado
    };

    mercado.content.push(tablaMercado);

    const comuna: any = this.createCardObj('card', 'Comuna', 'col-sm-12 col-md-6');

    const dataSourceTableComuna: any[] = [];

    dataSourceTableComuna.push(
      {
        name: 'Número empresas',
        value: this.content?.InformacionSectorialyDeMercado?.NumeroEmpresasEnComuna,
        type: 'int-clp'
      }
    );

    dataSourceTableComuna.push(
      {
        name: 'Total ventas en UF',
        value: this.content?.InformacionSectorialyDeMercado?.TotalVentasComunaEnUF,
        type: 'int-clp'
      }
    );

    dataSourceTableComuna.push(
      {
        name: 'Participacion relativa',
        value: this.content?.InformacionSectorialyDeMercado?.ParticipacionRelativaComuna,
        type: 'text'
      }
    );

    const tablaComuna = {
      type: 'table-basic',
      displayedColumns: ['name', 'value'],
      dataSource: dataSourceTableComuna
    };

    comuna.content.push(tablaComuna);    
    
    obj.content.push(mercado);
    obj.content.push(comuna);

    if(this.showInformacionSectorialyDeMercado) {
      const ventas: any = this.createCardObj('card', 'Ventas', 'col-sm-12 col-md-6');

      const dataSourceTableVentas: any[] = [];

      dataSourceTableVentas.push(
        {
          anio: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.ano1,
            type: 'text',
            class: ''
          },
          venta: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.periodo_1,
            type: 'int-clp',
            class: ''
          }
        }
      );

      dataSourceTableVentas.push(
        {
          anio: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.ano2,
            type: 'text',
            class: ''
          },
          venta: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.periodo_2,
            type: 'int-clp',
            class: ''
          }
        }
      );

      dataSourceTableVentas.push(
        {
          anio: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.ano3,
            type: 'text',
            class: ''
          },
          venta: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.periodo_3,
            type: 'int-clp',
            class: ''
          }
        }
      );

      dataSourceTableVentas.push(
        {
          anio: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.ano4,
            type: 'text',
            class: ''
          },
          venta: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.periodo_4,
            type: 'int-clp',
            class: ''
          }
        }
      );

      dataSourceTableVentas.push(
        {
          anio: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.ano5,
            type: 'text',
            class: ''
          },
          venta: {
            value: this.content?.InformacionSectorialyDeMercado?.TotalVentasHistoricoUF?.periodo_5,
            type: 'int-clp',
            class: ''
          }
        }
      );

      const tablaVentas = {
        type: 'table-header',
        displayedColumns: ['anio', 'venta'],
        headers: {
          anio: 'Año',
          venta: 'Venta en UF'
        },
        dataSource: dataSourceTableVentas
      };

      ventas.content.push(tablaVentas);

      obj.content.push(ventas);
    }

    const graficoVentas: any = this.createCardObj('card', 'Gráfico de Ventas', 'col-sm-12 col-md-6');

    graficoVentas.content.push({
      value: '',
      type: 'graphVentas'
    });

    obj.content.push(graficoVentas);

    return obj || {};
  }

  generateObsTributarias(): any {
    // Lógica para generar las observaciones tributarias
    const obj: any = this.createMatObj('Observaciones Tributarias', 'col-sm-12');

    const documentosTimbrados: any = this.createCardObj('card', 'Documento Timbrado', 'col-sm-12');

    const dataSourceTableTimbrados: any[] = [];

    if(this.content?.ObservacionesTributarias?.DocumentosTimbrados && this.content?.ObservacionesTributarias?.DocumentosTimbrados.length > 0) {
      for(const documento of this.content?.ObservacionesTributarias?.DocumentosTimbrados) {
        dataSourceTableTimbrados.push(
          {
            documento: {
              value: documento?.documento,
              type: 'text',
              class: ''
            },
            anio: {
              value: documento?.anoUltimoTimbraje,
              type: 'text',
              class: ''
            }
          }
        );
      }
    } else {
      dataSourceTableTimbrados.push(
        {
          documento: {
            value: "Sin Información",
            type: 'text',
            class: ''
          },
          anio: {
            value: "",
            type: 'text',
            class: ''
          }
        }
      );
    }

    const tablaTimbrados = {
      type: 'table-header',
      displayedColumns: ['documento', 'anio'],
      headers: {
        documento: 'Documento',
        anio: 'Año último Timbraje'
      },
      dataSource: dataSourceTableTimbrados
    };

    documentosTimbrados.content.push(tablaTimbrados);

    obj.content.push(documentosTimbrados);

    const observaciones: any = this.createCardObj('card', 'Observaciones', 'col-sm-12');

    const dataSourceTableObservaciones: any[] = [];

    if(this.content?.ObservacionesTributarias?.Observaciones && this.content?.ObservacionesTributarias?.Observaciones.length > 0) {
      for(const observacion of this.content?.ObservacionesTributarias?.Observaciones) {
        dataSourceTableObservaciones.push(
          {
            nombre: {
              value: observacion?.nombre,
              type: 'text',
              class: ''
            },
            descripcion: {
              value: observacion?.descripcion,
              type: 'text',
              class: ''
            }
          }
        );
      }
    } else {
      dataSourceTableObservaciones.push(
        {
          nombre: {
            value: "Sin Información",
            type: 'text',
            class: ''
          },
          descripcion: {
            value: "",
            type: 'text',
            class: ''
          }
        }
      );
    }

    const tablaObservaciones = {
      type: 'table-header',
      displayedColumns: ['nombre', 'descripcion'],
      headers: {
        nombre: 'Nombre',
        descripcion: 'Descripción'
      },
      dataSource: dataSourceTableObservaciones
    };

    observaciones.content.push(tablaObservaciones);

    obj.content.push(observaciones);

    return obj || {};
  }

  generateConsAlRut(): any {
    // Lógica para generar la consulta al RUT
    const obj: any = this.createMatObj('Consultas al Rut', 'col-sm-12');

    if(this.showConsultaRut) {
      obj.content.push({
        value: `Rut registra ${this.content?.AntecedentesComerciales?.ConsultasAlRut.length} consultas`,
        type: 'text-left'
      });

      const dataSourceTableConsultaRut: any[] = [];
  
      for(const item of this.content?.AntecedentesComerciales?.ConsultasAlRut) {
        dataSourceTableConsultaRut.push(
          {
            fecha: {
              value: item.FechaConsulta,
              type: 'date',
              class: ''
            },
            empresa: {
              value: item.RazonSocial,
              type: 'text',
              class: ''
            },
            informe: {
              value: item.InformeConsultado,
              type: 'text',
              class: ''
            }
          }
        );
      }
  
      const tablaConsultaRut = {
        type: 'table-header',
        displayedColumns: ['fecha', 'empresa', 'informe'],
        headers: {
          fecha: 'Fecha',
          empresa: 'Empresa',
          informe: 'Informe'
        },
        dataSource: dataSourceTableConsultaRut
      };
  
      obj.content.push(tablaConsultaRut);
    }

    return obj || {};
  }

  generateProtestosYMorosidad(): any {
    // Lógica para generar los protestos y morosidad
    const obj: any = this.createMatObj('Protestos y Morosidades', 'col-sm-12');

    obj.content.push({
      value: `Total M$ ${this.formatInteger((this.content?.AntecedentesComerciales?.Resumen?.ProtestosMonto ||
              0) + (this.content?.AntecedentesComerciales?.Resumen?.MorosidadesMonto || 0))}`,
      type: 'text-right'
    });

    if(this.showDetalleMorosidadesYProtestos) {
      const dataSourceTable: any[] = [];
  
      for(const detalle of this.content?.AntecedentesComerciales?.DetalleMorosidadesYProtestos) {
        dataSourceTable.push(
          {
            fechaVencimiento: {
              value: detalle?.fechaVencimiento,
              type: 'date',
              class: ''
            },
            tipoDocumento: {
              value: detalle?.tipoDocumento,
              type: 'text',
              class: ''
            },
            monto: {
              value: `${detalle?.moneda} ${this.formatInteger(detalle?.monto)}`,
              type: 'text',
              class: ''
            },
            localidad: {
              value: detalle?.localidad,
              type: 'text',
              class: ''
            },
            librador: {
              value: detalle?.librador,
              type: 'text',
              class: ''
            },
            tipoDeuda: {
              value: detalle?.tipoDeuda,
              type: 'text',
              class: ''
            },
            mercado: {
              value: detalle?.mercado,
              type: 'text',
              class: ''
            },
            tipoCredito: {
              value: detalle?.tipoCredito,
              type: 'text',
              class: ''
            },
            nChequeOperacion: {
              value: detalle?.nChequeOperacion,
              type: 'text',
              class: ''
            },
            fechaPublicacion: {
              value: detalle?.fechaPublicacion,
              type: 'date',
              class: ''
            }
          }
        );
      }
  
      const tabla = {
        type: 'table-header',
        displayedColumns: ['fechaVencimiento', 'tipoDocumento', 'monto', 'localidad', 'librador', 'tipoDeuda', 'mercado', 'tipoCredito', 'nChequeOperacion', 'fechaPublicacion'],
        headers: {
          fechaVencimiento: 'Vencimiento',
          tipoDocumento: 'Doc.',
          monto: 'Monto',
          localidad: 'Localidad',
          librador: 'Librador',
          tipoDeuda: 'Deuda',
          mercado: 'Mercado',
          tipoCredito: 'Crédito',
          nChequeOperacion: 'N° Cheque',
          fechaPublicacion: 'Publicación'
        },
        dataSource: dataSourceTable
      };
  
      obj.content.push(tabla);
    }

    return obj || {};
  }

  generateInformacionBoletinLaboral(): any {
    // Lógica para generar la información del boletín laboral
    const obj: any = this.createMatObj('Información Boletín Laboral', 'col-sm-12');

    obj.content.push({
      value: `Total M$ ${this.formatInteger(this.content?.AntecedentesComerciales?.Resumen?.InfraccionesLaboralesMonto || 0)}`,
      type: 'text-right'
    });

    if(this.showInformacionBoletinComercialLaboral) {
      const dataSourceTable: any[] = [];
  
      for(const detalle of this.content?.AntecedentesComerciales?.InformacionBoletinComercialLaboral) {
        dataSourceTable.push(
          {
            motivo: {
              value: detalle?.motivo,
              type: 'text',
              class: ''
            },
            meses: {
              value: detalle?.meses,
              type: 'text',
              class: ''
            },
            institucion: {
              value: detalle?.institucion,
              type: 'text',
              class: ''
            },
            boletin: {
              value: detalle?.boletin,
              type: 'text',
              class: ''
            },
            monto: {
              value: detalle?.monto,
              type: 'int',
              class: ''
            },
            pagina: {
              value: detalle?.pagina,
              type: 'text',
              class: ''
            },
            insp: {
              value: detalle?.insp,
              type: 'text',
              class: ''
            },
            fecha: {
              value: detalle?.fecha,
              type: 'date',
              class: ''
            },
            tipoInfraccion: {
              value: detalle?.tipoInfraccion,
              type: 'text',
              class: ''
            },
            resolutionNumber: {
              value: detalle?.resolutionNumber,
              type: 'text',
              class: ''
            }
          }
        );
      }
  
      const tabla = {
        type: 'table-header',
        displayedColumns: ['motivo', 'meses', 'institucion', 'boletin', 'monto', 'pagina', 'insp', 'fecha', 'tipoInfraccion', 'resolutionNumber'],
        headers: {
          motivo: 'Motivo',
          meses: 'Meses',
          institucion: 'Institución',
          boletin: 'Boletín',
          monto: 'Monto',
          pagina: 'Página',
          insp: 'Insp',
          fecha: 'Fecha',
          tipoInfraccion: 'Tipo Infracción',
          resolutionNumber: 'Resolución'
        },
        dataSource: dataSourceTable
      };
  
      obj.content.push(tabla);
    }

    return obj || {};
  }

  createMatObj(title: string, className: string): any {
    return {
      title: title,
      class: className,
      content: []
    };
  }

  createCardObj(type: string, title: string, className: string): any {
    return {
      type: type,
      title: title,
      class: className,
      content: []
    };
  }

  /*printPdf(): void {
    if(this.treeControl && this.treeControl?.dataNodes && this.treeControl?.dataNodes.length > 0) {
      this.treeControl.expandAll();
    }
    const elementButton = document.getElementById('btn-print');
    if (elementButton) {
      elementButton.click();
    }
  }*/

  descargarPDF(): void {
    const tx = this.content?.DatosBasicosSolicitud?.IDTransaccion || '';
    //console.log('this.content', this.content);
    if(tx) {
      this.descargarTX.emit(tx);
    }
  }

}
